(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7683],{

/***/ 15438:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var keyExistsOn = function keyExistsOn(o, k) {
  return k.split(".").reduce(function (a, c) {
    return a.hasOwnProperty(c) ? a[c] || 1 : false;
  }, Object.assign({}, o)) === false ? false : true;
};

/* harmony default export */ __webpack_exports__["Z"] = (keyExistsOn);

/***/ }),

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 68752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var IncludedFee = function IncludedFee(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "row mb-4 justify-between last:mb-0 lg:mb-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "col-12 self-center lg:col-6",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "h2",
            className: "bbc-title mb-4 text-center font-semibold text-bbc-brand-800 lg:mb-8 lg:text-left",
            text: item.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
            className: "mx-4 mb-6 list-disc leading-bbc-26 lg:mx-0 lg:mb-0 ",
            children: item.contents.map(function (content, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
                className: "  relative mb-2 list-none pl-5  text-bbc-gray before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-[5px] before:w-[5px] before:rounded-full before:bg-bbc-gray before:content-['']",
                children: content
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
          className: "col-12 text-center lg:col-6 ".concat(item.positionImage === "left" ? "lg:order-first lg:text-left" : "order-last lg:text-right"),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, item.img))
        })]
      }, index);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IncludedFee);
IncludedFee.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 32144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







function TabListNew(_ref) {
  var data = _ref.data,
      activeTab = _ref.activeTab,
      tabLinks = _ref.tabLinks,
      tabListClass = _ref.tabListClass,
      tabClass = _ref.tabClass,
      children = _ref.children,
      _onChange = _ref.onChange;
  var tabListStyle = ["rounded-full", tabListClass.display || "flex justify-start lg:justify-center", tabListClass.length || " w-fit mx-auto", tabListClass.background || "bg-transparent", tabListClass.padding || "p-0", tabListClass.border || "border md:border border-bbc-neutral-600", tabListClass.othersClass].join(" ");
  var tabStyle = ["relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center", tabClass.width || "w-fit", tabClass.textSize || "text-sm leading-6", tabClass.textFontWeight || "font-semibold", tabClass.padding || "py-3 px-6", tabClass.margin || "", tabClass.othersClass].join(" ");
  /* Handle Event */

  var handleOnClickTabLink = function handleOnClickTabLink(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "w-full",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
      defaultIndex: activeTab || 0,
      onChange: function onChange() {
        return _onChange && _onChange();
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.List */ .OK.List, {
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabListStyle),
        children: Object.keys(data).length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
            className: function className(_ref2) {
              var selected = _ref2.selected;
              return (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabStyle, selected ? "".concat(tabClass.tabColorActive || "border-bbc-brand-500 text-bbc-brand-500") : " ".concat(tabClass.tabColor || "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500", " "));
            },
            as: "div",
            children: [item.title || item, Array.isArray(tabLinks) && (tabLinks === null || tabLinks === void 0 ? void 0 : tabLinks.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
              "data-go": "#".concat(tabLinks[index]),
              onClick: handleOnClickTabLink,
              className: "absolute inset-0 h-full w-full"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})]
          }, item.id || item);
        })
      }), children]
    })
  });
}

TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TabListNew);

/***/ }),

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var OnlineBankingTool = function OnlineBankingTool(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "row justify-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "row col-12 rounded-3xl bg-bbc-gradient-9 py-6 lg:col-10 lg:py-0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: "col-12 order-1 self-center pr-0 lg:col-5 lg:order-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              text: data.title,
              as: "h5",
              className: "mb-6 pr-0 text-bbc-30px font-semibold capitalize text-bbc-main"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
              className: "mb-6 text-base font-normal text-white",
              children: data.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                target: "_blank",
                className: "rounded-[50px] border px-4 py-1 text-white ",
                href: "#",
                children: "Try Now"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: "col-12 order-0 text-center lg:col-7 lg:order-1 lg:text-left",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
              src: data.image,
              alt: "online baking tool"
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OnlineBankingTool);
OnlineBankingTool.defaultProps = {
  className: ""
};

/***/ }),

/***/ 10107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Icon_fa_FaCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27476);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47239);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Card = function Card(_ref) {
  var title = _ref.title,
      price = _ref.price,
      listContent = _ref.listContent;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "mb-10 lg:col-6",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().cardWrapper)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        as: "h3",
        text: title,
        className: "text-center text-bbc-30px font-semibold text-bbc-brand-700",
        style: {
          marginBottom: "30px"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
        className: "mb-8",
        children: listContent.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
            className: "relative mb-2",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Icon_fa_FaCheck__WEBPACK_IMPORTED_MODULE_0__/* .FaCheck */ .l, {
              className: "absolute top-1.5 left-0 text-bbc-brand-500",
              size: 12
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "inline-block pl-7",
              children: item.text
            })]
          }, index);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "border-t border-t-bbc-neutral-300 pt-8 pb-4 text-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
          className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().price)),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "US$"
          }), price]
        })
      })]
    })
  });
};

var Component = function Component(_ref2) {
  var title = _ref2.title,
      data = _ref2.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "m-auto lg:col-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "row justify-around",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Card, {
            title: item.title,
            price: item.price,
            listContent: item.listContent
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 49024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./common/data/bank_country_noselect.json
var bank_country_noselect = __webpack_require__(5891);
// EXTERNAL MODULE: ./common/data/bank_emis.json
var bank_emis = __webpack_require__(33148);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/BankingTable/index.js
var BankingTable = __webpack_require__(43200);
// EXTERNAL MODULE: ./components/organisms/BankingOptions/index.js + 1 modules
var BankingOptions = __webpack_require__(25497);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/OnlineBankingTool/index.js
var OnlineBankingTool = __webpack_require__(80651);
// EXTERNAL MODULE: ./components/molecules/IncludedFee/index.js
var IncludedFee = __webpack_require__(68752);
// EXTERNAL MODULE: ./components/templates/vn/company-registration/BankingPackages/index.js
var BankingPackages = __webpack_require__(10107);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/PackageAndFee/index.js







var Component = function Component(_ref) {
  var _data$dataBankingPack;

  var data = _ref.data,
      country = _ref.country,
      title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    id: "banking_options",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "bbc-title mb-6 text-center capitalize",
          text: title ? title : "Open a Bank Account for ".concat(country, " Company ")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "m-auto w-5/6 text-center",
          dangerouslySetInnerHTML: {
            __html: data.note || "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply."
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative overflow-hidden pt-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container relative z-20",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "row justify-center",
          children: ((_data$dataBankingPack = data.dataBankingPackage) === null || _data$dataBankingPack === void 0 ? void 0 : _data$dataBankingPack.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BankingPackages/* default */.Z, {
            data: data.dataBankingPackage
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/top_bg-wave.png",
        width: 1920,
        height: 125,
        className: "w-full",
        wrapper: {
          className: "w-full absolute left-0 right-0 z-10 ",
          style: {
            top: "6rem"
          }
        },
        alt: "Wave top"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " absolute bottom-0 z-0 h-full w-full bg-bbc-package",
        style: {
          top: "100px"
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-bbc-package pt-10 lg:pt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(IncludedFee/* default */.Z, {
          data: data.included
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " absolute hidden h-1/2 w-full bg-bbc-package md:block"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/bottom-wave.png",
        width: 1920,
        height: 140,
        className: "w-full",
        wrapper: {
          className: "absolute w-full top-1/2 hidden md:block"
        },
        alt: "Wave bottom"
      })]
    })]
  });
};

/* harmony default export */ var PackageAndFee = (Component);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
;// CONCATENATED MODULE: ./components/templates/vn/open-bank-account/index.js















var NewsSlider = (0,dynamic["default"])(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8352), __webpack_require__.e(1290)]).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/vn/open-bank-account/index.js -> " + "components/organisms/NewsSlider"]
  }
});
var traditionalThead = ["Country", "Bank", "Online Banking", "Personal Visit", "Credit Card", "Debit Card", "Initial Deposit"];

var VNOpenBankAccountTemplate = function VNOpenBankAccountTemplate(_ref) {
  var data = _ref.data,
      dataJson = _ref.dataJson;
  var country = dataJson.country,
      breadcrumbs = dataJson.breadcrumbs,
      dataHowToOpen = dataJson.dataHowToOpen,
      dataOpenBankFee = dataJson.dataOpenBankFee;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: breadcrumbs,
      title: "Bank Account Opening For ".concat(country, " Company"),
      titleProps: {
        className: "banner-default-title mb-10",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: dataJson !== null && dataJson !== void 0 && dataJson.imgBanner ? dataJson === null || dataJson === void 0 ? void 0 : dataJson.imgBanner : "/assets/images/common/open-bank.png",
        className: "w-full ",
        wrapper: {
          className: "bbc-banner-image-country pb-10 lg:pb-0 "
        },
        width: 591,
        height: 412,
        priority: true,
        alt: "bank account opening service in Vietnam"
      }),
      bgColor: "bg-bbc-country"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: dataHowToOpen.title,
          className: "bbc-title mt-10 mb-10 text-center capitalize lg:mt-20"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "paragraph ".concat(country.toLowerCase() === "singapore" && "blue-marker"),
          children: dataHowToOpen.content.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              dangerouslySetInnerHTML: {
                __html: item
              }
            }, index);
          })
        }), dataHowToOpen.note ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: dataHowToOpen.note
          }
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: " mt-4 border-l-4 border-bbc-brand-700 pl-2 font-medium",
            children: ["Wonder which can be the best bank for your ", country, " company? Let's find out with our", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
              href: "/guide-and-tool/banking-tool",
              target: "_blank",
              className: "text-bbc-brand-500",
              children: "Banking Tool"
            })]
          })
        })]
      })
    }), dataJson.dataOnlineBankingTool && typeof dataJson.dataOnlineBankingTool === "object" && Object.keys(dataJson.dataOnlineBankingTool).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OnlineBankingTool/* default */.Z, {
        data: dataJson.dataOnlineBankingTool
      })
    }), dataOpenBankFee && Object.keys(dataOpenBankFee).length > 0 && dataOpenBankFee.dataBankingPackage.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "pb-10 lg:pb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PackageAndFee, {
        data: dataOpenBankFee,
        country: country,
        title: dataOpenBankFee.title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        className: "my-6 pb-0 text-center text-2xl font-semibold leading-[44px] text-bbc-brand-800 md:my-8 md:text-3xl",
        children: "Banking Options for Vietnam Company"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hidden md:block",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingTable/* default */.Z, {
          data: bank_country_noselect/* vietnam */.d,
          className: "mt-4",
          thead: traditionalThead
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-6 block md:hidden ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingOptions/* BankMobile */.N, {
          data: bank_country_noselect/* vietnam */.d,
          thead: traditionalThead
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        title: dataJson.dataRequiredDocument.title || "Required Documents",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20",
        backgroundImage: "/assets/images/common/required-documents.png"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var open_bank_account = (VNOpenBankAccountTemplate);
VNOpenBankAccountTemplate.defaultProps = {
  data: {},
  posts: []
};
;// CONCATENATED MODULE: ./pages/vn/open-bank-account/data.json
var data_namespaceObject = JSON.parse('{"country":"Vietnam","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Open bank account","uri":"/open-bank-account"}],"imgBanner":"/assets/images/sg/open-bank-account/open_bank-sg-oba.png","dataHowToOpen":{"note":"  ","title":"Vietnam Banking System","content":["Vietnam has a two-tier banking system, under which the state bank of Vietnam performs the role of the central bank in managing currency and banking. The second tier comprises commercial banks and credit institutions providing banking and financial services in compliance with the law on Credit Institutions as core legislation.","The banking sector plays a pivotal role, and also accounts for the largest part of Vietnam\'s financial system. As of mid-2020, commercial banks include 4 state-owned banks, 31 joint-stock commercial banks, 9 wholly-owned foreign banks, and 2 joint venture commercial banks. Remarkably, four state-owned commercial banks, namely Agribank, BIDV, Vietinbank, and Vietcombank predominate with nearly 50 % of the total market share in bank deposits at the 2019 year-end.","Vietnam\'s banking system, like many frontier money markets, has long stacked up against its systematic risks with low liquidity, weak and insufficient regulatory and supervision framework, thin capital buffer, and so on. After the banking crisis in 2011 submerged the whole industry, until then the state bank has taken steps to address its structural weaknesses, with the aim of system stability.","Vietnam holds a conservative view on its foreign exchange policy, but without lessening attraction to foreign investment flows. In particular, it regulated all investors have to open Direct or Indirect Capital Accounts at a local licensed bank to make any transaction related to that foreign investor."]},"dataOpenBankFee":{"note":"<span class=\'font-medium\'>Note:</span> If you would like to request our banking support to open business account with our supported Vietnam banks, please consider our proposal below which does not include the fee for bank account application or any other related fee (if any) chargeable by the bank you choose to apply.","dataBankingPackage":[{"title":"Basic Banking Support","price":299,"listContent":[{"text":"One-time fee for application of one bank"},{"text":"Consulting on the preparation of your chosen bank’s required documents"},{"text":"Preparing certified translated corporate documents if needed"},{"text":"Making appointment with your chosen bank in the supported list"}]},{"title":"Premium Banking Support","price":599,"listContent":[{"text":"One-time fee for application of up to 3 banks OR till account opened successfully, whichever comes first"},{"text":"Consulting on the preparation of your chosen bank\'s required documents"},{"text":"Preparing certified translated corporate documents if needed"},{"text":"Meeting at registered office address for all applications"}]}],"included":[{"title":"What Included in Our Fee","contents":["Consult on local banking partners that best suit your needs","Guide you through the whole process, and answer all your bank related queries","Help you prepare and review your documents before submitting","Support in getting your foreign documents translated and properly certified","Set up appointment with your chosen bank"],"img":{"src":"/assets/images/vn/open-bank-account/our_service-vn-open_bank.png","width":412,"height":419,"alt":"what included in fee"},"positionImage":"right"},{"title":"Why Our Service is Unique","contents":["One-time fee for multi bank applications with premium package","Long-term relationship with a wide range of local banking partners","Dedicated support team that answers all your queries even on weekends","Prompt response and easy-to-follow guide for application"],"img":{"src":"/assets/images/vn/open-bank-account/our_service1-vn-open_bank.png","width":445,"height":435,"alt":"why our service is unique"},"positionImage":"left"}]},"dataRequiredDocument":{"note":"","title":"Account opening required docs ","button":{"type":"talk-to","text":"Talk To Our Expert"},"button_image":{},"content":[{"title":"Opening capital account for foreign enterprises is straightforward and quite easy. Though each bank might have different requirements. The below list of documents should serve you well for pre-consideration."},{"title":"","listContent":[{"text":"Account application form","content":[]}]},{"title":"For company’s authorized account holder, chief accountant (or accounting staff) or any related person:"},{"title":"","listContent":[{"text":"A valid ID or passport with at least 6 months to expiry date","content":[]},{"text":"Authorization letter (if any)","content":[]}]},{"title":"If related people are non-resident, following would be required"},{"title":"","listContent":[{"text":"A valid Vietnam visa with a duration of a minimum of 1 year issued within the last 12 months; OR","content":[]},{"text":"Any of the below documents with a validity of 1 year or longer, also issued within the past 12 months:","content":["Temporary Resident Card (TRC)","Work Permit","Permanent Resident Card (PRC)","Temporary resident confirmation"]}]},{"title":"For foreign company:"},{"title":"","listContent":[{"text":"Legal proofs of business establishment and operation such as business registration certificate, investment license, tax code registration, registered company stamp, etc.","content":[]}]}]}}');
;// CONCATENATED MODULE: ./pages/vn/open-bank-account/index.js






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "vn",
    navLight: true,
    page: data === null || data === void 0 ? void 0 : data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(open_bank_account, {
      data: data,
      dataJson: data_namespaceObject,
      dataBank: {
        traditional: bank_country_noselect/* vietnam */.d,
        emi: bank_emis.vietnam
      }
    })
  });
}

/***/ }),

/***/ 85692:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/open-bank-account",
      function () {
        return __webpack_require__(49024);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Index_cardWrapper__q92F_","price":"Index_price__3yVeZ"};

/***/ }),

/***/ 5891:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"d":[{"name":"Vietnam","banks":[{"name":"Vietcombank","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true},{"name":"Techcombank","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true},{"name":"Sacombank","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true},{"name":"HSBC","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true},{"name":"Citibank","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true},{"name":"Standard Chartered","online_banking":true,"personal_visit":true,"credit_card":true,"debit_card":true}]}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,9973,5955,9131,4090,9738,7447,2864,58,5999,2888,179], function() { return __webpack_exec__(85692); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);